"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.productDataApi = productDataApi;
exports.productRankApi = productRankApi;
exports.productTrendApi = productTrendApi;
exports.tradeDataApi = tradeDataApi;
exports.tradeOverviewApi = tradeOverviewApi;
exports.tradeTrendApi = tradeTrendApi;
exports.userAreaData = userAreaData;
exports.userChannelData = userChannelData;
exports.userOverviewData = userOverviewData;
exports.userOverviewListApi = userOverviewListApi;
exports.userSexData = userSexData;
exports.userTotalData = userTotalData;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

/**
 * 商品统计数据
 * @param pram
 */
function productDataApi(params) {
  return (0, _request.default)({
    url: "/admin/statistics/product/data",
    method: 'GET',
    params: params
  });
}

/**
 * 商品排行数据
 * @param pram
 */
function productRankApi(params) {
  return (0, _request.default)({
    url: "/admin/statistics/product/ranking",
    method: 'GET',
    params: params
  });
}

/**
 * 商品趋势数据
 * @param pram
 */
function productTrendApi(params) {
  return (0, _request.default)({
    url: "/admin/statistics/product/trend",
    method: 'GET',
    params: params
  });
}

/**
 * 交易统计数据
 * @param pram
 */
function tradeDataApi() {
  return (0, _request.default)({
    url: "/admin/statistics/trade/data",
    method: 'GET'
  });
}

/**
 * 交易概览
 * @param pram
 */
function tradeOverviewApi(params) {
  return (0, _request.default)({
    url: "/admin/statistics/trade/overview",
    method: 'GET',
    params: params
  });
}

/**
 * 交易趋势
 * @param pram
 */
function tradeTrendApi(params) {
  return (0, _request.default)({
    url: "/admin/statistics/trade/trend",
    method: 'GET',
    params: params
  });
}

/**
 * 用户总数据
 * @param pram
 */
function userTotalData() {
  return (0, _request.default)({
    url: "/admin/statistics/user/total/data",
    method: 'GET'
  });
}

/**
 * 用户区域数据
 * @param pram
 */
function userAreaData() {
  return (0, _request.default)({
    url: "/admin/statistics/user/area",
    method: 'GET'
  });
}

/**
 * 用户渠道数据
 * @param pram
 */
function userChannelData() {
  return (0, _request.default)({
    url: "/admin/statistics/user/channel",
    method: 'GET'
  });
}

/**
 * 用户概览
 * @param pram
 */
function userOverviewData(params) {
  return (0, _request.default)({
    url: "/admin/statistics/user/overview",
    method: 'GET',
    params: params
  });
}

/**
 * 用户性别数据
 * @param pram
 */
function userSexData() {
  return (0, _request.default)({
    url: "/admin/statistics/user/sex",
    method: 'GET'
  });
}

/**
 * 用户概览列表
 * @param pram
 */
function userOverviewListApi(params) {
  return (0, _request.default)({
    url: "/admin/statistics/user/overview/list",
    method: 'GET',
    params: params
  });
}